<template>
  <v-dialog v-model="dialogState" width="70%">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Please fix the listed issues to continue the import process
        <v-btn color="black" text @click="$emit('dialogEvent')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-4">
        <v-row>
          <v-col
              v-for="(item, index) in importErrors"
              :key="index"
              cols="6"
              sm="6"
          >
            <v-card class="mb-2 pa-1 " elevation="1" outlined>
              <h1 class="text-h4">Row Number--{{ index }}</h1>
              <v-list-item>
                <v-list-item-content>
                  <v-card
                      v-for="message in item"
                      :key="message"
                      class="mb-2 pa-1 "
                      outlined
                  >
                    <v-icon class="mr-2" color="red">mdi-alert</v-icon>
                    <v-list-item-title v-html="message"></v-list-item-title>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('dialogEvent')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["importErrors", "dialogState"],
  data() {
    return {}
  },
};
</script>
